"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableHeadOverlay = void 0;
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const theming_1 = require("../../theming");
const checkbox_1 = __importDefault(require("../checkbox"));
const table_1 = require("./table");
const paddings = {
    small: "sm",
    medium: 12,
    large: "md",
};
const useStyles = (0, theming_1.createUseStyles)(({ colors, spacing, typography, ...theme }) => ({
    wrapper: {
        position: "sticky",
        left: spacing(48),
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        maxWidth: "100%",
        width: "100%",
        minHeight: theme.size(21),
        backgroundColor: colors.lighterprimary,
    },
    checkbox: ({ size }) => ({
        width: theme.size(16),
        minWidth: "min-content",
        padding: spacing(paddings[size], "sm", paddings[size], paddings[size]),
    }),
    container: ({ size }) => ({
        padding: spacing(paddings[size], paddings[size], paddings[size], "sm"),
        fontSize: typography.small.fontSize,
        fontWeight: typography.fontWeights.bold,
    }),
}));
exports.TableHeadOverlay = react_1.default.forwardRef(function TableHeadOverlay({ actions, allSelected = false, children, className, hidden = false, indeterminate = false, selectable: selectableCheckbox, onSelect, ...props }, ref) {
    const { selectable, size } = (0, react_1.useContext)(table_1.TableContext);
    const classes = useStyles({ size });
    return (react_1.default.createElement("div", { ref: ref, className: (0, classnames_1.default)(classes.wrapper, className), ...props },
        (selectable || selectableCheckbox) && (react_1.default.createElement("div", { className: classes.checkbox },
            react_1.default.createElement(checkbox_1.default, { indeterminate: indeterminate, value: allSelected, onChange: onSelect }))),
        react_1.default.createElement("div", { className: classes.container },
            children,
            actions)));
});
exports.default = exports.TableHeadOverlay;
//# sourceMappingURL=data:application/json;base64,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